import { SxProps, Theme } from '@mui/system';
import React from 'react';
import { DeviceType, useBreakpoint } from '../../../hooks/useBreakpoint';
import { StyledDocumentHeaderBox } from '../CfDocumentViewer.styles';
import CfDocumentViewerDownloadButton from './buttons/CfDocumentViewerDownloadButton';
import CfDocumentViewerPrintButton from './buttons/CfDocumentViewerPrintButton';

interface CfDocumentViewerHeaderProps {
  fileName: string;
  fileSrc: string;
  downloadBlob: Blob;
  containerSx?: SxProps<Theme>;
}

const CfDocumentViewerHeader: React.FC<CfDocumentViewerHeaderProps> = (props: CfDocumentViewerHeaderProps) => {
  const { fileName, fileSrc, containerSx } = props;
  const { deviceType } = useBreakpoint();
  const canPrint = deviceType === DeviceType.Desktop;
  return (
    <StyledDocumentHeaderBox sx={{ ...containerSx }}>
      {canPrint && (
        <CfDocumentViewerPrintButton
          fileName={fileName}
          fileSrc={fileSrc}
          variant='contained'
          size='small'
          text='Print'
        />
      )}
      <CfDocumentViewerDownloadButton
        fileName={fileName}
        fileSrc={props.downloadBlob}
        variant='contained'
        size={deviceType === DeviceType.Tablet || deviceType === DeviceType.Mobile ? 'medium' : 'small'}
        text='Download'
        sx={{ ml: 1 }}
      />
    </StyledDocumentHeaderBox>
  );
};

export default CfDocumentViewerHeader;
